import moment, { MomentInput } from 'moment';

interface OfsDateParser {
    // Define the structure of the OfsDateParser interface
    age(value: string): number;
    format(value: string, formatString?: string): string;
    formatDateWithAutoHypen(value: string, formatString?: string): string;
    formatDob(value: string): string;
    formatIso(value: string): string;
    isAdultDob(value: string): boolean;
    isValidDate(value: string): boolean;
    parse(value: string): MomentInput | null;
}

const ofsDateParser: OfsDateParser = {
  formatDateWithAutoHypen(value: string): string {
    let [month, day, year] = value.split("-");

    let updatedValue1 = month;

    if (month !== undefined && month.length === 2) {
      month = month.slice(0, 2) + "-";
    } else if (
      month !== undefined &&
      month.length < 2 &&
      day === undefined &&
      year === undefined
    ) {
      month = month.slice(0, 1);
    } else if (
      month !== undefined &&
      month.length < 2 &&
      (day !== undefined || year !== undefined)
    ) {
      month = month + "-";
    } else if (
      month !== undefined &&
      month.length > 2 &&
      (day === undefined || day.length === 0)
    ) {
      let tempMonth = month;
      month = tempMonth.slice(0, 2) + "-";
      day = tempMonth.slice(2);
    }

    if (day !== undefined && day.length === 2) {
      day = day.slice(0, 2) + "-";
    } else if (day !== undefined && day.length < 2 && year === undefined) {
      day = day.slice(0, 1);
    } else if (
      day !== undefined &&
      day.length < 2 &&
      day.length >= 1 &&
      year !== undefined
    ) {
      day = day + "-";
    }
    else if (
      day !== undefined &&
      day.length === 4 &&
      year === undefined
    ) {
      year = day;
      day = "";
     
    }
     else if (
      day !== undefined &&
      day.length > 2 &&
      (year === undefined || year.length === 0)
    ) {
      let tempDay = day;
      day = tempDay.slice(0, 2) + "-";
      year = tempDay.slice(2);
    }

    if (year !== undefined && day === "") {
      day = day + "-";
    }

    updatedValue1 =
      (month === undefined ? "" : month) +
      (day === undefined ? "" : day) +
      (year === undefined ? "" : year);

    let date = value.replace(/[^\d]/g, "");

    if (date.length >= 8) {
      updatedValue1 = date.slice(0, 2) + "-" + date.slice(2);
      updatedValue1 = updatedValue1.slice(0, 5) + "-" + date.slice(4);
    }

    if (date.length === 0) {
      updatedValue1 = "";
    }
    return updatedValue1;
  },

  age(value: string): number {
    const date = this.parse(value);
    return moment().diff(date, "years");
  },

  format(value: string, formatString: string = "MM-DD-YYYY"): string {
    const date = this.parse(value);
    return date ? moment(date).format(formatString) : "";
  },

  formatDob(value: string): string {
    const date = this.parse(value);
    return date ? moment(date).format("MMMM D, YYYY") : "";
  },

  formatIso(value: string): string {
    const date = this.parse(value);
    return date ? moment(date).format("YYYY-MM-DD") : "";
  },

  isAdultDob(value: string): boolean {
    return this.age(value) >= 18;
  },

  isValidDate(value: string): boolean {
    return !!this.parse(value);
  },

  parse(value: string): MomentInput | null {
    const date =
      Object.prototype.toString.call(value) === "[object Date]"
        ? moment(value)
        : moment(
            value,
            ["M-D-YYYY", "M/D/YYYY", "MM-DD-YYYY", "MM/DD/YYYY"],
            true
          );

    return date.isValid() ? date : null;
  },
};

export default ofsDateParser;
